/* 
/* PCナビゲーション
*/
$(function () {
  var btn = $("#dropdown");
  if (btn.length) {
    btn.click(function () {
      $(this).toggleClass("is-open");
      $(".pc-bg-black").toggleClass('active');
    });
  }
});

$(".pc-bg-black").on("click", function () {
    $(this).toggleClass('active');
    $("#dropdown").toggleClass('is-open');
});


/* 
/* ハンバーガーメニューの処理
*/
$(".openbtn").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".sp-nav-wrap").toggleClass('active');
    $(".sp-bg-black").toggleClass('active');
    $("body").toggleClass('fixed');
});

$(".sp-bg-black").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".sp-nav-wrap").toggleClass('active');
    $(".openbtn").toggleClass('active');
    $("body").toggleClass('fixed');
});


/* 
/* メニュー内アコーディオン
*/
$('.ac-ttl').click(function(){ 
    $(this).parent().next('.add-submenu').slideToggle();
    $(this).toggleClass("open");
  });